module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/crocodile-star2.b5aa45f2.png";